import { render, staticRenderFns } from "./MigrationClean.vue?vue&type=template&id=863fd304&"
import script from "./MigrationClean.vue?vue&type=script&lang=js&"
export * from "./MigrationClean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports